import { GLServiceBase, ServiceRoute } from "commonui";
import { ITagListManager } from "./interface";
import { CreateTagRequestModel, EditTagRequestModel, TagListResponseModel } from "./model";

class TagListServiceClass extends GLServiceBase<any, any> implements ITagListManager {
	serviceRoute: ServiceRoute = { prefix: "content/v1/VcsContent" };

	createTag(model: CreateTagRequestModel): Promise<boolean> {
		return this.create("tag", model, undefined);
	}

	editTag(model: EditTagRequestModel): Promise<boolean> {
		return this.update("tag", model, undefined);
	}

	getTagList(): Promise<TagListResponseModel[]> {
		return this.get("tagList");
	}

	deleteTag(tagId: number): Promise<boolean> {
		return this.delete(`tag/${tagId}`);
	}
}

export const TagListManagerService = () => new TagListServiceClass();
